import { useEffect, useState } from 'react';
/**
 * Lets a component wait until it mounts before rendering content that needs the DOM, such as a
 * portal into `document.body`. Server and hydration renders skip that content, so their markup
 * matches.
 *
 * To avoid updating a component after it unmounts, such as when async work finishes, use
 * `useIsMounted` instead.
 */
export function useClientRender() {
    const [isClientRender, setIsClientRender] = useState(false);
    useEffect(() => {
        setIsClientRender(true);
    }, []);
    return isClientRender;
}
//# sourceMappingURL=useClientRender.js.map